var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9353 3.02384H9.47482V1.56472C9.47482 0.977846 8.99697 0.5 8.4101 0.5H1.06472C0.477846 0.5 0 0.977846 0 1.56472V8.91144C0 9.49832 0.477846 9.97616 1.06472 9.97616H2.52384V11.4353C2.52384 12.0222 3.00168 12.5 3.58856 12.5H10.9353C11.5222 12.5 12 12.0222 12 11.4353V4.08856C11.9987 3.50168 11.5208 3.02384 10.9353 3.02384ZM1.06472 9.11335C0.953001 9.11335 0.86147 9.02182 0.86147 8.9101V1.56472C0.86147 1.453 0.953001 1.36147 1.06472 1.36147H8.41144C8.52316 1.36147 8.61469 1.453 8.61469 1.56472V8.91144C8.61469 9.02316 8.52316 9.11469 8.41144 9.11469H1.06472V9.11335ZM11.1372 11.4353C11.1372 11.547 11.0457 11.6385 10.9339 11.6385H3.58856C3.47684 11.6385 3.38531 11.547 3.38531 11.4353V9.97482H8.41144C8.99832 9.97482 9.47616 9.49697 9.47616 8.9101V3.88531H10.9353C11.047 3.88531 11.1385 3.97684 11.1385 4.08856V11.4353H11.1372Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.59e6721233fe1c9655817dc7aa8d6c62.svg";
export { ForwardRef as ReactComponent };